<!-- Modal Esqueci Minha Senha -->
<div class="modal-overlay" (click)="fechar()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Recuperar Senha</h2>
      <button class="btn-close" (click)="fechar()">&times;</button>
    </div>
    
    <div class="modal-body">
      <p class="modal-description">Digite seu email para recuperação de senha.</p>
      
      <form [formGroup]="forgotPasswordForm" (ngSubmit)="enviarEmailRecuperacao()">
        <div class="form-group">
          <label for="emailRecuperacao">Email</label>
          <input 
            type="email"  
            class="form-control" 
            id="emailRecuperacao" 
            formControlName="email" 
            placeholder="Digite seu email">
          
          <div *ngIf="forgotPasswordForm.get('email')?.invalid && forgotPasswordForm.get('email')?.touched">
            <div *ngIf="forgotPasswordForm.get('email')?.hasError('required')" class="formatacaoRequireds">
              *Email é obrigatório
            </div>
            <div *ngIf="forgotPasswordForm.get('email')?.hasError('email')" class="formatacaoRequireds">
              *Email inválido
            </div>
          </div>
        </div>

        <div class="modal-buttons">
          <button type="button" class="btn-cancelar" (click)="fechar()" [disabled]="enviando">
            Cancelar
          </button>
          <button type="submit" class="btn-enviar" [disabled]="enviando">
            Enviar
          </button>
        </div>
      </form>
    </div>
  </div>
  
  <!-- Loading Overlay - Cobre toda a tela -->
  <div class="loading-overlay-fullscreen" *ngIf="enviando">
    <div class="loading-spinner">
      <div class="spinner"></div>
      <p>Enviando...</p>
    </div>
  </div>
</div>

